import React, { useEffect, useState } from 'react';
import rest from '../axios';

export default function RatingsReportComponente() {
  const [userRatings, setUserRatings] = useState([]);
  const [commentsByCondominium, setCommentsByCondominium] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchReport() {
      try {
        setLoading(true);
        const response = await rest.get('/admin/reports/ratings');
        setUserRatings(response.data?.data?.userRatingsWithLevel || []);
        setCommentsByCondominium(response.data?.data?.commentsWithPercentage || []);
      } catch (err) {
        setError('Erro ao carregar o relatório.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    fetchReport();
  }, []);

  if (loading) return <div className="text-center mt-5">Carregando relatório...</div>;
  if (error) return <div className="text-danger text-center mt-5">{error}</div>;

  return (
    <div className="container mt-4">
      <h2 className="fw-bold mb-4">Relatório de Avaliações</h2>

      <div className="card shadow-sm p-4 mb-4">
        <h5 className="fw-bold">Número total de avaliações por usuário</h5>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Usuário (ID)</th>
              <th>Nível</th>
              <th>Total de Avaliações</th>
            </tr>
          </thead>
          <tbody>
            {userRatings.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">Nenhum registro encontrado</td>
              </tr>
            ) : (
              userRatings.map(rating => (
                <tr key={rating.user_id}>
                  <td>{rating.user_name}</td>
                  <td>{rating.level || 'Sem nível'}</td>
                  <td>{rating.totalAvaliacoes}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="card shadow-sm p-4">
        <h5 className="fw-bold">Porcentagem de Comentários por Condomínio (baseado em moradores)</h5>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Condomínio</th>
              <th>Total de Avaliações</th>
              <th>Porcentagem</th>
            </tr>
          </thead>
          <tbody>
            {commentsByCondominium.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">Nenhum registro encontrado</td>
              </tr>
            ) : (
              commentsByCondominium.map(comment => (
                <tr key={comment.community_id}>
                  <td>{comment.condominium || 'Condomínio Desconhecido'}</td>
                  <td>{comment.total}</td>
                  <td>{comment.percentual}%</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
